import { render, staticRenderFns } from "./sales-order-list.vue?vue&type=template&id=49647be4&"
import script from "./sales-order-list.vue?vue&type=script&lang=js&"
export * from "./sales-order-list.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports